/**
 * @fileoverview Main application component that provides authentication context
 * and navigation structure using Toolpad Core's ReactRouterAppProvider.
 */

import { useMemo } from 'react';
import { Outlet } from 'react-router';
import { ReactRouterAppProvider } from './providers/ReactRouterAppProvider';
import { HighlightThemeProvider } from './components';
import { useNavigation } from './hooks';
import { useAuth, AuthSessionContext, AUTHENTICATION } from '../features/auth';
import { BRANDING } from '@/config/app';
import { customTheme, injectCustomFonts } from '@/config/theme';

// Initialize custom fonts early in the application lifecycle
injectCustomFonts();

export default function App() {
  const { session, setSession, loading } = useAuth();
  const { navigation } = useNavigation();

  const sessionContextValue = useMemo(
    () => ({
      session,
      setSession,
      loading,
    }),
    [session, setSession, loading],
  );

  return (
    <ReactRouterAppProvider
      navigation={navigation}
      branding={BRANDING}
      session={session}
      authentication={AUTHENTICATION}
      theme={customTheme}
    >
      <HighlightThemeProvider />
      <AuthSessionContext.Provider value={sessionContextValue}>
        <Outlet />
      </AuthSessionContext.Provider>
    </ReactRouterAppProvider>
  );
}
